module.exports = __webpack_public_path__ + "assets/img/银河特工队.db87c796.png";